import React, { Component } from "react";
import Core from "Core";
import { observer } from "mobx-react";
import UnitBinding from "../../UnitBinding";

export default observer(
  class Unit extends Component {
    static defaultProps = {
      unit: new UnitBinding()
    };

    render() {
      let {
        label,
        model,
        dataMember,
        placeholder,
        unit,
        validationState
      } = this.props;

      return (
        <Core.Components.FormGroups.LabelValuePair
          label={label}
          validationState={validationState}
        >
          <Core.Components.Inputs.Unit
            model={model}
            dataMember={dataMember}
            placeholder={placeholder}
            unit={unit}
          />
        </Core.Components.FormGroups.LabelValuePair>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Core/Components/FormGroups/Unit.js